import HowDidYouHearReferralStep from '@/pages/members/pages/Onboarding/steps/HowDidYouHearReferralStep';
import {
  OnboardingNodeType,
  OnboardingStepType
} from '@/pages/members/pages/Onboarding/steps/types';
import { OnboardingNode } from '@/pages/members/pages/Onboarding/types';

export const HOW_DID_YOU_HEAR_WITH_REFERRAL_DROPDOWN_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.HOW_DID_YOU_HEAR_ABOUT_US,
  options: { countsTowardProgressBar: false, hideProgressBar: true, optional: true },
  elements: [
    {
      uid: OnboardingStepType.HOW_DID_YOU_HEAR_ABOUT_US,
      component: (
        <HowDidYouHearReferralStep
          uid={OnboardingStepType.HOW_DID_YOU_HEAR_ABOUT_US}
          nodeType={OnboardingNodeType.HOW_DID_YOU_HEAR_ABOUT_US}
          displayName=""
          actionButtonText="Finish"
        />
      )
    }
  ]
};
